import { render } from "./Account.vue?vue&type=template&id=8a9fe806"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"
script.render = render

export default script